import "core-js/modules/es.function.name.js";
import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-045c6062"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  id: "play-list-head"
};
var _hoisted_2 = {
  key: 0,
  class: "list-head-box"
};
var _hoisted_3 = {
  class: "list-left"
};
var _hoisted_4 = {
  class: "popover-head"
};
var _hoisted_5 = {
  class: "popover-body"
};
var _hoisted_6 = {
  class: "cate-box"
};
var _hoisted_7 = {
  class: "tag-box"
};
var _hoisted_8 = ["onClick"];
var _hoisted_9 = {
  class: "right-tag-badge"
};
var _hoisted_10 = {
  class: "mv-cate-list"
};
var _hoisted_11 = ["onClick"];
var _hoisted_12 = {
  class: "list-right"
};
var _hoisted_13 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_ArrowRight = _resolveComponent("ArrowRight");

  var _component_el_icon = _resolveComponent("el-icon");

  var _component_el_scrollbar = _resolveComponent("el-scrollbar");

  var _component_el_popover = _resolveComponent("el-popover");

  return _openBlock(), _createElementBlock(_Fragment, null, [_createCommentVNode(" 弹出框 "), _createElementVNode("div", _hoisted_1, [_createCommentVNode(" 标签区域 "), _ctx.listTag.length && _ctx.allTagList.length ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createCommentVNode(" 弹出框 "), _createVNode(_component_el_popover, {
    placement: "bottom-start",
    width: 650,
    trigger: "click"
  }, {
    reference: _withCtx(function () {
      return [_createCommentVNode(" 左边 "), _createElementVNode("div", _hoisted_3, [_createElementVNode("span", null, _toDisplayString(_ctx.tagName), 1
      /* TEXT */
      ), _createVNode(_component_el_icon, {
        size: 18
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_ArrowRight)];
        }),
        _: 1
        /* STABLE */

      })])];
    }),
    default: _withCtx(function () {
      return [_createVNode(_component_el_scrollbar, {
        "max-height": "400px"
      }, {
        default: _withCtx(function () {
          return [_createCommentVNode(" 弹出框内容 "), _createElementVNode("div", _hoisted_4, [_createElementVNode("span", {
            class: _normalizeClass([_ctx.tagName === _ctx.scrollTopTitle && 'isTag']),
            onClick: _cache[0] || (_cache[0] = function ($event) {
              return _ctx.tagClick(_ctx.scrollTopTitle);
            })
          }, _toDisplayString(_ctx.scrollTopTitle), 3
          /* TEXT, CLASS */
          )]), _createCommentVNode(" 类别区域 "), _createElementVNode("div", _hoisted_5, [_createCommentVNode(" 歌单类别区域 "), _ctx.route.path === '/main/playlist' ? (_openBlock(true), _createElementBlock(_Fragment, {
            key: 0
          }, _renderList(_ctx.cate, function (item1, index1) {
            return _openBlock(), _createElementBlock("div", {
              class: "body-item",
              key: index1
            }, [_createCommentVNode(" 左边类别 "), _createElementVNode("div", _hoisted_6, [_createElementVNode("i", {
              class: _normalizeClass(['iconfont', item1.icon])
            }, null, 2
            /* CLASS */
            ), _createElementVNode("span", null, _toDisplayString(item1.title), 1
            /* TEXT */
            )]), _createCommentVNode(" 右边标签 "), _createElementVNode("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tageCateList[index1], function (item2, index2) {
              return _openBlock(), _createElementBlock("div", {
                class: "tag-list",
                key: index2,
                onClick: function onClick($event) {
                  return _ctx.tagClick(item2.name);
                }
              }, [_createElementVNode("div", {
                class: _normalizeClass(['right-tag-item', _ctx.tageCateName == item2.name && 'isTag'])
              }, [_createTextVNode(_toDisplayString(item2.name) + " ", 1
              /* TEXT */
              ), _withDirectives(_createElementVNode("span", _hoisted_9, "HOT", 512
              /* NEED_PATCH */
              ), [[_vShow, item2.hot]])], 2
              /* CLASS */
              )], 8
              /* PROPS */
              , _hoisted_8);
            }), 128
            /* KEYED_FRAGMENT */
            ))])]);
          }), 128
          /* KEYED_FRAGMENT */
          )) : _ctx.route.path === '/main/video' ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 1
          }, [_createCommentVNode(" 视频类别区域 "), _createElementVNode("div", _hoisted_10, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allTagList, function (item, index) {
            return _openBlock(), _createElementBlock("div", {
              class: "mv-cate-item",
              key: index,
              onClick: function onClick($event) {
                return _ctx.tagClick(item.name, item.id);
              }
            }, [_createElementVNode("span", {
              class: _normalizeClass([_ctx.tageCateName == item.name && 'isTag'])
            }, _toDisplayString(item.name), 3
            /* TEXT, CLASS */
            )], 8
            /* PROPS */
            , _hoisted_11);
          }), 128
          /* KEYED_FRAGMENT */
          ))])], 2112
          /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */
          )) : _createCommentVNode("v-if", true)])];
        }),
        _: 1
        /* STABLE */

      })];
    }),
    _: 1
    /* STABLE */

  }), _createCommentVNode(" 右边 "), _createElementVNode("div", _hoisted_12, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listTag, function (item, index) {
    return _openBlock(), _createElementBlock("div", {
      class: "list-right-tag",
      key: index,
      onClick: function onClick($event) {
        return _ctx.tagClick(item.name || item, item.id);
      }
    }, [_createElementVNode("span", {
      class: _normalizeClass(['tag-item', _ctx.isItem === (item.name || item) && 'active'])
    }, _toDisplayString(item.name || item), 3
    /* TEXT, CLASS */
    )], 8
    /* PROPS */
    , _hoisted_13);
  }), 128
  /* KEYED_FRAGMENT */
  ))])])) : _createCommentVNode("v-if", true)])], 2112
  /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */
  );
}